import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Adam Locke --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Verify Observability Platform is receiving log data";
const frontMatter = {
  "title": "Verify Observability Platform is receiving log data",
  "description": "Learn how to verify that Chronosphere Observability Platform is ingesting your log data.",
  "robots": "noindex, nofollow"
};
import {Icon} from '@/components';
import {mdiCompass} from '@mdi/js';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Verify Observability Platform is receiving log data"}</_components.h1>{"\n"}<_components.p>{"After "}<_components.a href="/ingest/logs">{"ingesting data"}</_components.a>{", use Logs Explorer to verify that Chronosphere\nObservability Platform is receiving log data."}</_components.p>{"\n"}<_components.ol>{"\n"}<_components.li>{"\n"}<_components.p>{"In the navigation menu select\n"}<_components.strong><Icon path={mdiCompass} />{" Explorers "}<span aria-label="and then">{">"}</span>{" Logs Explorer"}</_components.strong>{"."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"On the "}<_components.strong>{"Logs Explorer"}</_components.strong>{" page, select a time window that includes the period when\nObservability Platform started ingesting log data."}</_components.p>{"\n"}<_components.p>{"The timeline graph displays a spike at the time when Observability Platform\nstarted ingesting log data."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Verify the "}<_components.code>{"message"}</_components.code>{", "}<_components.code>{"timestamp"}</_components.code>{", "}<_components.code>{"service"}</_components.code>{", and "}<_components.code>{"severity"}</_components.code>{" fields are being\nassigned correctly. If these fields aren’t mapped in the way you intended, contact\n"}<_components.a href="/support">{"Chronosphere Support"}</_components.a>{"."}</_components.p>{"\n"}</_components.li>{"\n"}</_components.ol></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/ingest/logs/verify-logs',
  {"filePath":"pages/ingest/logs/verify-logs.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)